"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Link from "./webflow_modules/Basic/components/Link";

export function AdvSearchSearchInputViewAllLocations({ buttonProps = {} }) {
  return (
    <Block className={"adv-search---result-item-container-copy"} tag={"div"}>
      <Link
        button={false}
        className={"link-2"}
        options={{
          href: "#",
        }}
        {...buttonProps}
      >
        {"Show All Locations"}
      </Link>
    </Block>
  );
}
